import { render, staticRenderFns } from "./setUser.vue?vue&type=template&id=425646a3&scoped=true&"
import script from "./setUser.vue?vue&type=script&lang=js&"
export * from "./setUser.vue?vue&type=script&lang=js&"
import style0 from "./setUser.vue?vue&type=style&index=0&id=425646a3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425646a3",
  null
  
)

export default component.exports